export default __webpack_public_path__ + "static/media/secretary.67ef00b3.jpg";